import * as rhStore from './store'

export function rhModule({ store }) {
  store.registerModule('rh', {
    ...rhStore,
    namespaced: true,
  })
}
